// Shared bits between the promo card add and edit forms.
export const PLACEMENT_OPTIONS = [
  { value: 'home', text: 'Home' },
  { value: 'my_team', text: 'My Team' },
  { value: 'players', text: 'Players' },
  { value: 'rankings', text: 'Rankings' },
]

// What the date pickers show.
export const formatDisplayDate = (date) => {
  if (!date) return ''
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${day}/${month}/${date.getFullYear()}`
}

// What the API stores.
export const toApiDate = (date) => {
  if (!date) return ''
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}
